<div class="modal-header">
    <h5 class="modal-title">Edit Multi Agreement Type Options</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <p>Example: If you want to offer 1, 3, and 5 year contract options, then A = 1 Year, B = 3 Years, and C = 5 Years.</p>
    <div [formGroup]="multiAgreementTypeForm">
        <!-- A -->
        <div formGroupName="A" class="input-group">
            <div class="input-group-text">
                <input id="MULTI_AGREEMENT_A_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
            </div>
            <span class="input-group-text" style="width: 42px; display: block;">A</span>
            <input id="MULTI_AGREEMENT_A_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="1" formControlName="numOfYears" min="1">
            <span class="input-group-text">Year(s)</span>
        </div>
        <!-- B -->
        <div formGroupName="B" class="input-group mt-2">
            <div class="input-group-text">
                <input id="MULTI_AGREEMENT_B_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
            </div>
            <span class="input-group-text" style="width: 42px; display: block;">B</span>
            <input id="MULTI_AGREEMENT_B_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="2" min="1" formControlName="numOfYears">
            <span class="input-group-text">Year(s)</span>
        </div>
        <!-- C -->
        <div formGroupName="C" class="input-group mt-2">
            <div class="input-group-text">
                <input id="MULTI_AGREEMENT_C_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
            </div>
            <span class="input-group-text" style="width: 42px; display: block;">C</span>
            <input id="MULTI_AGREEMENT_C_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="3" min="1" formControlName="numOfYears">
            <span class="input-group-text">Year(s)</span>
        </div>
        <!-- D -->
        <div formGroupName="D" class="input-group mt-2">
            <div class="input-group-text">
                <input id="MULTI_AGREEMENT_D_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
            </div>
            <span class="input-group-text" style="width: 42px; display: block;">D</span>
            <input id="MULTI_AGREEMENT_D_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="4" min="1" formControlName="numOfYears">
            <span class="input-group-text">Year(s)</span>
        </div>
        <!-- E -->
        <div formGroupName="E" class="input-group mt-2">
            <div class="input-group-text">
                <input id="MULTI_AGREEMENT_E_IS_ENABLED" type="checkbox" class="form-check-input mt-0" formControlName="isEnabled">
            </div>
            <span class="input-group-text" style="width: 42px; display: block;">E</span>
            <input id="MULTI_AGREEMENT_E_NUMBER_OF_YEARS" type="number" class="form-control" placeholder="5" min="1" formControlName="numOfYears">
            <span class="input-group-text">Year(s)</span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="updateProposalMultiOptions();">Save</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Close</button>
</div>